import { useI18n } from "../i18n/LanguageContext";
import { useSeo } from "../hooks/useSeo";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FAQ() {
  const { t, lang } = useI18n();
  useSeo({ title: t.seo.faq.title, description: t.seo.faq.description, path: "/faq", lang });
  return (
    <section className="container-wide py-16 md:py-24">
      <div className="grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="eyebrow">{t.faq.eyebrow}</p>
          <h1 className="mt-4 text-4xl md:text-5xl tracking-tight font-medium text-foreground">{t.faq.title}</h1>
          <p className="mt-5 text-muted-foreground leading-relaxed">{t.home.ctaSub}</p>
          <Link to="/contact" className="mt-6 inline-flex items-center gap-1.5 text-sm text-accent link-underline" data-testid="faq-contact-link">
            {t.common.contact_us} <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="border-y border-border" data-testid="faq-accordion">
            {t.faq.items.map((it, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-border" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left py-6 text-lg font-medium hover:no-underline hover:text-accent">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-6 pr-8">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
